import React, { Component, ReactElement } from 'react'
import { Route } from '../Annotation/Route'
import { RouteID } from '../Components/Molecules/Header/Types/Types'
import { RouteGuard } from '../Guards/RouteGuard'
import { useDisableUserInfoErrors } from '../../React/Common/Hooks/useDisableUserInfoErrors'
import { CookiePolicy } from '../Components/Organisms/CookiePolicy/CookiePolicy'

@Route(RouteID.COOKIE_POLICY)
export class CookiePolicyPage extends Component {
    render(): ReactElement {
        useDisableUserInfoErrors()

        return (
            <RouteGuard route={RouteID.COOKIE_POLICY}>
                <CookiePolicy />
            </RouteGuard>
        )
    }
}
